import { EGarageStatus } from '../../../../api-models/common/json_query';

export const GARAGE_STATUSES_MAP_VALUE_TO_LABEL = {
  [EGarageStatus.Ownership]: 'Собственность',
  [EGarageStatus.Agreement]: 'По доверенности',
  [EGarageStatus.Cooperative]: 'Кооператив',
};
